
// Hardcoded restrictions configuration
export interface RestrictionSetting {
  type: string; // Keep for backward compatibility with existing code
  name: string; // Human-readable name
  backend_name: string; // Apple Developer documentation key
  parent_id?: string;
}

export const HARDCODED_RESTRICTIONS: RestrictionSetting[] = [
  {
    type: "airdrop",
    name: "AirDrop",
    backend_name: "allowAirDrop"
  },
  {
    type: "apple_music",
    name: "Apple Music",
    backend_name: "allowMusicService"
  },
  {
    type: "siri",
    name: "Siri",
    backend_name: "allowAssistant"
  },
  {
    type: "siri_profanity_filter",
    name: "Siri Profanity Filter",
    backend_name: "forceAssistantProfanityFilter",
    parent_id: "siri"
  },
  {
    type: "apple_watch",
    name: "Apple Watch",
    backend_name: "allowPairedWatch"
  },
  {
    type: "erase_all_content",
    name: "Erase All Content",
    backend_name: "allowEraseContentAndSettings"
  },
  {
    type: "facetime",
    name: "FaceTime",
    backend_name: "allowVideoConferencing"
  },
  {
    type: "imessage",
    name: "iMessage",
    backend_name: "allowChat"
  },
  {
    type: "personal_hotspot",
    name: "Personal Hotspot Modification",
    backend_name: "allowPersonalHotspotModification"
  },
  {
    type: "pairing",
    name: "Pairing",
    backend_name: "allowHostPairing"
  },
  {
    type: "siri_suggestions",
    name: "Siri Suggestions",
    backend_name: "allowSpotlightInternetResults"
  },
  {
    type: "siri_user_content",
    name: "Siri User Generated Content",
    backend_name: "allowAssistantUserGeneratedContent"
  }
];

export const getHardcodedRestrictions = (): RestrictionSetting[] => {
  return HARDCODED_RESTRICTIONS;
};

export const getHardcodedRestrictionById = (id: string): RestrictionSetting | undefined => {
  return HARDCODED_RESTRICTIONS.find(r => r.type === id);
};
